/**
 * Per-turn git diff: compare working tree at end of the agent turn to the pre-turn stash snapshot
 * (`git stash create` written under `.buildautomaton/snapshots/<runId>.json`), forwarded as
 * `session_file_change` for that turn's runId.
 */

import type { LogFn } from '../../../log.js';
import { forEachWithGitYield } from '../../git-runtime.js';
import { collectRepoTurnChanges } from './collect-repo-changes.js';
import { loadPreTurnSnapshot } from './load-pre-turn-snapshot.js';

export async function collectTurnGitDiffFromPreTurnSnapshot(options: {
  sessionId: string;
  runId: string;
  agentCwd: string;
  sendSessionUpdate: (p: unknown) => void;
  log: LogFn;
}): Promise<void> {
  const { sessionId, runId, agentCwd, sendSessionUpdate, log } = options;
  const data = await loadPreTurnSnapshot({ agentCwd, runId, log });
  if (!data) return;

  const multiRepo = data.repos.length > 1;
  await forEachWithGitYield(data.repos, async (repo) => {
    await collectRepoTurnChanges({
      repo,
      multiRepo,
      sessionId,
      runId,
      sendSessionUpdate,
      log,
    });
  });
}
